import { Directive } from '@angular/core';

@Directive({
  selector: 'panel-footer'
})
export class PanelFooterDirective { }
